import { For } from "solid-js";

export function TextField(props: {
  label: string;
  value: string;
  onInput: (value: string) => void;
}) {
  return (
    <label class="editor-field">
      <span class="editor-field-label">{props.label}</span>
      <input
        class="editor-input"
        type="text"
        value={props.value}
        onInput={(event) => props.onInput(event.currentTarget.value)}
      />
    </label>
  );
}

export function TextArea(props: {
  label: string;
  value: string;
  rows?: number;
  onInput: (value: string) => void;
}) {
  return (
    <label class="editor-field">
      <span class="editor-field-label">{props.label}</span>
      <textarea
        class="editor-input"
        rows={props.rows ?? 4}
        value={props.value}
        onInput={(event) => props.onInput(event.currentTarget.value)}
      />
    </label>
  );
}

/**
 * Generic over its option values so a caller holding a contract enum gets that
 * enum back, rather than a bare string it has to cast.
 */
export function SelectField<T extends string>(props: {
  label: string;
  value: T;
  options: readonly { value: T; label: string }[];
  onInput: (value: T) => void;
}) {
  return (
    <label class="editor-field">
      <span class="editor-field-label">{props.label}</span>
      <select
        class="editor-input"
        value={props.value}
        onChange={(event) => {
          const selected = props.options.find(
            (option) => option.value === event.currentTarget.value,
          );
          // A select can only emit one of its own options, so a miss means the
          // option list and the DOM disagree — a bug, not a user action.
          if (!selected) {
            throw new Error(`Unknown option: ${event.currentTarget.value}`);
          }
          props.onInput(selected.value);
        }}
      >
        <For each={props.options}>
          {(option) => <option value={option.value}>{option.label}</option>}
        </For>
      </select>
    </label>
  );
}

export function NumberField(props: {
  label: string;
  value: number;
  onInput: (value: number) => void;
}) {
  return (
    <label class="editor-field">
      <span class="editor-field-label">{props.label}</span>
      <input
        class="editor-input mono"
        type="number"
        value={String(props.value)}
        onInput={(event) =>
          props.onInput(Number.parseInt(event.currentTarget.value, 10))
        }
      />
    </label>
  );
}
